<h2 mat-dialog-title i18n>Register SSO Credential</h2>
<form [formGroup]="proxyForm">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label i18n>Username</mat-label>
      <input matInput formControlName="username" required>
      @if (proxyForm['username']?.hasError('required')) {
        <mat-error i18n>Username is required</mat-error>
      }
    </mat-form-field>

    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()" i18n>Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="proxyForm.invalid" (click)="onSubmit()" i18n>Submit</button>
    </mat-dialog-actions>
  </mat-dialog-content>
</form>
